import React from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useChartToolbar } from "../../common/function/useChartToolbar";

interface Measurement {
  resistanceLeftAvr: number;
  resistanceRightAvr: number; 
}

interface ImpedanceChartProps {
  xAxisData: string[];
  measurements: Measurement[];
  resistanceType: "left" | "right";
}

const ImpedanceChart: React.FC<ImpedanceChartProps> = ({ xAxisData, measurements ,resistanceType }) => {
  const toolbar = useChartToolbar();
  
  // Map the measurements to an array of resistanceLeftAvr values
  const seriesData = measurements.map((m) => {
    const resistance = resistanceType === "left" ? m.resistanceLeftAvr : m.resistanceRightAvr;
    return resistance;
  });
  // Compute dynamic min and max values for the y-axis
  const minValue = seriesData.length ? Math.min(...seriesData) : 0;
  const maxValue = seriesData.length ? Math.max(...seriesData) : 10000;

  const options: ApexOptions = {
    chart: {
      id: "impedance-chart",
      toolbar,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "5px",
        borderRadius: 0,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: xAxisData,
      labels: {
        show: true,
        rotate: -45, 
        style: {
          fontSize: "10px",
          colors: "#7B7484",
        },
      },
      tickAmount: 19,
    },
    yaxis: {
      title: {
        text: "Impedance (ohms)",
        style: {
          fontSize: "12px",
          fontFamily: "Poppins",
          fontWeight: 400,
          color: "#202224",
        },
      },
      labels: {
        style: {
          fontSize: "12px",
          colors: "#7B7484",
        },
        formatter: (value: number) => value.toFixed(0), 
      },
      min: minValue,
      max: maxValue,
      tickAmount: 5,
    },
    grid: {
      borderColor: "#E0E0E0",
      strokeDashArray: 2,
      position: "back",
    },
    colors: [
      "rgba(59, 156, 185, 1)"
    ],
    tooltip: {
      enabled: true,
      theme: "light",
      x: {
        formatter: (val: number | string) => `Time: ${val}`,
      },
      y: {
        formatter: (val: number) => `${val} ohms`,
      },
    },
  };

  const series = [
    {
      name: "Impedance",
      data: seriesData,
    },
  ];

  return (
    <div style={{ position: "relative", width: "100%", height: "auto" }}>
      <Chart options={options} series={series} type="bar" height={567} />
    </div>
  );
};

export default ImpedanceChart;
